import './App.css';
import { useContext, useEffect, useState } from "react";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import Answer from './components/Answer';
import Standard from './components/Standard';
import {
  createBrowserRouter,
  Link,
  Outlet,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import { Options } from './gamemodes/Options';
import { OptionsContext } from './context/globalContext';
import { Drawer, Box, List, ListItem, ListItemButton } from '@mui/material';
import GameModes from './gamemodes/GameModes';
import SingleGame from './components/SingleGame';
import Endless from './components/Endless';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

var env
if (window.location.hostname === 'localhost' || window.location.hostname.includes('holoquiz-9cf44')) {
  console.log('DEV')
  env = 'dev'
}else{
  console.log('PROD')
  env = 'prod'
}

export const db = startFirebase(env)

function startFirebase(env) {
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  if (env === 'dev') {
    
    const firebaseConfig = {
      apiKey: "AIzaSyBwuiR1WjhdjY16nUsi6hQ7iMXQhbUnJcQ",
      authDomain: "holoquiz-9cf44.firebaseapp.com",
      projectId: "holoquiz-9cf44",
      storageBucket: "holoquiz-9cf44.appspot.com",
      messagingSenderId: "99765866376",
      appId: "1:99765866376:web:ae8ca59dc7f759d5a3743d",
      measurementId: "G-1NNS9XTJSC"
    };
    
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    
    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    return db
  }else if (env === 'prod') {
    const firebaseConfig = {
      apiKey: "AIzaSyDLQr3JssYnrJkQ196mwc202EYCWNcpCYI",
      authDomain: "holomusicquiz.firebaseapp.com",
      databaseURL: "https://holomusicquiz-default-rtdb.firebaseio.com",
      projectId: "holomusicquiz",
      storageBucket: "holomusicquiz.appspot.com",
      messagingSenderId: "574254160594",
      appId: "1:574254160594:web:4df1f1790b2b132d6a2b0b",
      measurementId: "G-1Z8BJWXLG5"
    };
    
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    
    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    return db
  }
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Homepage/>,
    children: [
      {
        path: "/single/gamemodes",
        element: <GameModes/>
      },
      {
        path: "/single/standard",
        element: <SingleGame gamemode={'standard'}/>
      },
      {
        path: "/single/endless",
        element: <SingleGame gamemode={'endless'}/>
      },
      {
        path: "/single/hardcore",
        element: <SingleGame gamemode={'hardcore'}/>
      },
      {
        path: "/single/standard/play",
        element: <Standard/>
      },
      {
        path: "/single/endless/play",
        element: <Endless gamemode={'endless'}/>
      },
      {
        path: "/single/hardcore/play",
        element: <Endless gamemode={'hardcore'}/>
      },
    ]
  },
  {
    path: "/play",
    element: <Play/>
  } 
]);

var globalOptions

function App() {
  return (
    <RouterProvider router={router}>
      <div className="App">
        <Play/>
      </div>
    </RouterProvider>
  );
}

export function createOptions() {
  localStorage.removeItem('options')
  const options = { //setting default option values
    guessTime: 20,
    numberOfSongs: 5,
    numberOfLives: 3,
    defaultVolume: 40,
    branches: {
      en: true,
      id: true,
      jp: true
    },
    songType: {
      original: true,
      cover: false
    }
  }

  localStorage.setItem('options', JSON.stringify(options))
}

function loadOptions(){
  var options = JSON.parse(localStorage.getItem("options"))
  return options
}

if(!localStorage.getItem('options')){
  createOptions()
}else{
  globalOptions = loadOptions()
}

function Homepage() {
  const [options, setOptions] = useState()
  const [menuIcon, setMenuIcon] = useState('menu')
  const [menu, setMenu] = useState(false)
  
  const location = useLocation()

  useEffect(() => {
    if(!options){
      setOptions(globalOptions)
    }

    console.log(options)
  
    return () => {
      
    }
  }, [options])
  
  const toggleMenu = (open) => () =>  {
    setMenu(open)
    open ? setMenuIcon('close') : setMenuIcon('menu')
  }

  const Menu = (
    <Box role="presentation" onClick={toggleMenu(false)} className='menu'>
      <div className='menu-top'>
        <Link to={'/'}><img className='logo pointer' src="/HoloMusicQuizLogo.svg" alt="holo music quiz logo" />  </Link>
        <img src={`close.svg`} alt="" onClick={toggleMenu(true)} className='pointer close'/>
      </div>
      <Link to={'single/gamemodes'}>Single Player</Link>
      <Link className='wip'>Multiplayer (WIP)</Link>
      <Link className='wip'>About (WIP)</Link>
    </Box>

  )

  return (
    <div className='homepage'>
      <header>
        <div className='header-menu'>
          <Link to={'/'}><img className='logo pointer' src="/HoloMusicQuizLogo.svg" alt="holo music quiz logo" />  </Link>
          <img src="/menu.svg" alt="" onClick={toggleMenu(true)} className='pointer open'/>
        </div>
        
        <img className='game-logo' src="/Logo.svg" alt="game logo" />

        <div className='header-user'>
          <img className='profile-icon wip' src="/account_circle.svg" alt="profile icon" />
        </div>
      </header>

      <main className='main'>
        <Drawer open={menu} onClose={toggleMenu(false)}>
          {Menu}
        </Drawer>
        
        {location.pathname === '/' ? <Play/> : <Outlet/>}

      </main>
      <footer>
        <p>Made by <a href='https://twitter.com/dlton_ico'>Dalton</a> - v{process.env.REACT_APP_VERSION}</p>
      </footer>
    </div>
  )
}

function Play() {
  return (
    <>
      <div className="overlay"></div>
      <div className="block-video block-homepage">
        <Link to={'single/gamemodes'}><img src="play_circle.svg" alt="Play" className='player-icon'/></Link>
      </div>
    </>
  )
}

export default App;
